import { FGTextInput } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";
import * as Yup from "yup";

import { KennelApi, PersonApi, PersonGridDto, SaveKennelOwnerDto } from "../../../../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IKennelOwnerSavePanelProps {
  onSaved: () => void;
  person: PersonGridDto;
  kennelId: number;
  kennelOwnershipId: number;
}

export const KennelOwnerSavePanel: React.FunctionComponent<IKennelOwnerSavePanelProps> = ({
  person,
  onSaved,
  kennelId,
  kennelOwnershipId,
}) => {
  const { t } = useTl();
  const api = useApiService(KennelApi);
  const personApi = useApiService(PersonApi);
  const { id } = useParams<{ id: string }>();

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      ownerFrom: Yup.date()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("is-not-owner", t(ETLCodes.AlreadyIsKennelOwner), async function (value) {
          if (value) {
            const result = await personApi.isKennelOwner(
              this.parent?.personId,
              kennelOwnershipId > 0 ? +id : 0,
              value,
              this.parent.ownerTo
            );
            return !result.value;
          }
          return true;
        }),
      ownerTo: Yup.date()
        .nullable()
        .test("is-not-owner", t(ETLCodes.AlreadyIsKennelOwner), async function (value) {
          if (value) {
            const result = await personApi.isKennelOwner(
              this.parent?.personId,
              kennelOwnershipId > 0 ? +id : 0,
              this.parent.ownerFrom,
              value
            );
            return !result.value;
          }
          return true;
        }),
    });
  }, [id, kennelOwnershipId, personApi, t]);

  const { data, loading, saving, saveItem } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: (kId = kennelOwnershipId) =>
          kId
            ? api.getKennelOwnership(kId)
            : new SaveKennelOwnerDto({
                kennelId: kennelId,
                personId: person?.personId,
              }),
        saveApiFn: async (d: any) => {
          console.log("saving ", d);
          var res = await api.addNewKennelOwner(d);
          onSaved();
          return res;
        },
      }),
      [api, kennelId, kennelOwnershipId, onSaved, person?.personId]
    )
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={data}
      editMode={true}
      validationSchema={FormSchema}
      saving={saving}
      loading={loading}
    >
      <FGTextInput name="personName" label={t(ETLCodes.OwnerSelected)} readonly />
      <FGSRSHDateMaskInput name="ownerFrom" label={t(ETLCodes.OwnerFrom)} />{" "}
      <FGSRSHDateMaskInput name="ownerTo" label={t(ETLCodes.OwnerTo)} />
    </SmallFormGenerator>
  );
};
